<template>
  <div class="continer">
    <ul>
      <li>
        <h4>
          经营范围：建设工程施工图审查（房屋建筑：含铁路工程、水利工程、交通工程），
          城市建设、工业建筑、电力工程、信息工程、石油和化工建设工程、矿山工程、人防工程
          、广播电影电视工程和民航机场工程的施工图审查。
        </h4>
      </li>
    </ul>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="stylus" scoped>
.continer 
  width 100%
  color #333
  li 
    margin-bottom 50px
    h4 
      font-size 14px
      line-height 30px
      text-indent 2em
    p 
      font-size 12px
      line-height 30px
</style>
